module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/lexi-poster-f5e7beea0bf748b1f86048e458c5f23a.jpg";